import { getGetPartnersEmbeddedOnboardingPartnerDataQueryKey, useGetPartnersEmbeddedOnboardingPartnerData } from 'utils/web_api'

import { useEmbeddedOnboarding } from './useEmbeddedOnboarding'

export const useEmbeddedPartner = () => {
  const { embeddedOnboardingToken, isEmbedded } = useEmbeddedOnboarding()
  return useGetPartnersEmbeddedOnboardingPartnerData({
    query: {
      enabled: isEmbedded,
      queryKey: [
        getGetPartnersEmbeddedOnboardingPartnerDataQueryKey(),
        embeddedOnboardingToken,
      ]
    }
  })
}
